import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

function ProductStockPop({ isPopup, setIsPopup, stockData, onConfirm, onCancel }){
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };

  const handleBackgroundClick = (e) => {
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  const handleConfirm = () => {
    // stockData.data에서 delete_cart_option 배열 생성
    const deleteCartOption = stockData?.data?.map(item => ({
      cart_option_seq: parseInt(item.seq),
      remove_ea: parseInt(item.delete_ea)
    })) || [];

    if (onConfirm) {
      onConfirm(deleteCartOption); // 생성된 배열을 전달
    }
    setIsPopup(false);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    setIsPopup(false);
  };

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className="pop_title line">재고 부족 상품</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
              <div className="pop_addr_con scroll_custom">
                <ul className="default_info_list stock_list">
                  {stockData?.data && stockData?.data.length > 0 ? (
                    stockData?.data.map((item, index) => (
                      <li key={index} className="info_item">
                        <div className="stock_con flex-btw">
                          <div className="stock_text">
                            <h4>{item?.name}</h4>
                            <p>
                              선택하신 수량 <span>{item?.ea}개</span> 중 
                              <span>{item?.available_stock}개</span> 주문 가능합니다.
                            </p>
                          </div>
                          {/* <p className="red">주문 불가 {item.delete_ea}</p> */}
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="info_item">
                      <div className="stock_con flex-btw">
                        <div className="stock_text">
                          <h4>재고부족 상품이 없습니다.</h4>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
                <div className='guide_text_1 g-80 mt_16'>{stockData?.message}</div>

              <div className='pop_btn_wrap'>
                <button 
                  type="button"
                  className="default_btn light_gray pop_con_btn mt_16" 
                  onClick={handleCancel}
                >
                  취소
                </button>
                <button 
                  type="button"
                  className="default_btn black pop_con_btn mt_16" 
                  onClick={handleConfirm}
                >
                  확인
                </button>
              </div>

            </div>
          </div>
        </div>
    );
};

export default ProductStockPop;